import { SHARED_STEPS } from './shared.steps';
import { backButton, nextButton } from '../tourButtons';

export function getManagerSteps(t) {
  return [
    SHARED_STEPS.welcome(t),
    SHARED_STEPS.sidebar(t),

    {
      id: 'air-pollution',
      attachTo: { element: '[data-tour="nav-air-pollution"]', on: 'right' },
      title: t('tour.airPollution.title'),
      text: t('tour.airPollution.text'),
      buttons: [backButton(t), nextButton(t)],
    },

    {
      id: 'monitoring',
      attachTo: { element: '[data-tour="nav-monitoring"]', on: 'right' },
      title: t('tour.monitoring.title'),
      text: t('tour.monitoring.text'),
      buttons: [backButton(t), nextButton(t)],
    },

    {
      id: 'climate',
      attachTo: { element: '[data-tour="nav-climate"]', on: 'right' },
      title: t('tour.climate.title'),
      text: t('tour.climate.text'),
      buttons: [backButton(t), nextButton(t)],
    },

    {
      id: 'meteorology',
      attachTo: { element: '[data-tour="nav-meteorology"]', on: 'right' },
      title: t('tour.meteorology.title'),
      text: t('tour.meteorology.text'),
      buttons: [backButton(t), nextButton(t)],
    },

    SHARED_STEPS.settings(t),
    SHARED_STEPS.help(t),
    SHARED_STEPS.done(t),
  ];
}
